export default __webpack_public_path__ + "static/google-play_download_es-496e9c65bd7fe939db1a90d1adb6c414.png";